import React from 'react'
import styled, { css } from 'styled-components'

import Button from './Button'
import { CLIENT_STYLINGS } from '../../../utils/constants'
import { getBorderRadius } from '../../../utils/styleUtils'

const getVariantStyles = props => {
  const { variant, theme } = props
  const colors = CLIENT_STYLINGS[theme.organizationSlug].COLOR

  switch (variant) {
    case 'primary':
      return {
        backgroundColor: colors.PRIMARY,
        color: colors.PRIMARY_FOREGROUND,
        border: '1px solid transparent',
      }
    case 'secondary':
      return {
        backgroundColor: colors.SECONDARY,
        color: colors.SECONDARY_FOREGROUND,
        border: '1px solid transparent',
      }
    case 'outline':
      return {
        backgroundColor: colors.BACKGROUND,
        color: colors.FOREGROUND,
        border: `1px solid ${colors.BORDER}`,
      }
    case 'ghost':
      return {
        backgroundColor: 'transparent',
        color: colors.FOREGROUND,
        border: '1px solid transparent',
      }
    default:
      return {
        backgroundColor: colors.PRIMARY,
        color: colors.PRIMARY_FOREGROUND,
        border: '1px solid transparent',
      }
  }
}

const getSizeStyles = props => {
  const { size } = props

  switch (size) {
    case 'sm':
      return {
        minHeight: '28px',
        fontSize: '12px',
        lineHeight: '18px',
        paddingLeft: '10px',
        paddingRight: '10px',
      }
    case 'lg':
      return {
        minHeight: '40px',
        fontSize: '15px',
        lineHeight: '20px',
        paddingLeft: '24px',
        paddingRight: '24px',
      }
    case 'default':
    default:
      return {
        minHeight: '36px',
        fontSize: '14px',
        lineHeight: '20px',
        paddingLeft: '16px',
        paddingRight: '16px',
      }
  }
}

export const StyledButton = styled(Button).attrs(props => ({
  style: {
    ...getVariantStyles(props),
    ...getSizeStyles(props),
  },
}))`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 20px;
  text-decoration: none;
  white-space: normal;
  word-wrap: break-word;
  min-height: 36px;
  border-radius: ${props => getBorderRadius(props, 'sm')};
  box-sizing: border-box;
  cursor: pointer;
  transition: background-color 0.1s;
  font-weight: 400 !important;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};

  &:hover {
    background-color: ${props => {
      const colors = CLIENT_STYLINGS[props.theme.organizationSlug].COLOR
      switch (props.variant) {
        case 'primary':
          return `${colors.PRIMARY}BF`
        case 'secondary':
          return `${colors.SECONDARY}BF`
        case 'outline':
        case 'ghost':
          return `${colors.SECONDARY}80`
        default:
          return `${colors.PRIMARY}BF`
      }
    }} !important;
  }

  &:focus,
  &:active {
    outline: none;
  }
  &:after {
    content: none;
  }
  &:before {
    content: none;
  }

  &:disabled,
  &[aria-disabled='true'] {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;
  }
`

StyledButton.defaultProps = {
  type: 'button',
  variant: 'primary',
  size: 'default',
}
